import { SignInPage, useAuthContext } from "@eisox/auth";
import { createFileRoute, Link, redirect } from "@tanstack/react-router";

import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/sign-in")({
  validateSearch: search => ({
    redirect: (search.redirect as string) || "/",
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: search.redirect });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { signIn } = useAuthContext("SignIn");
  const { redirect: redirectTo } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <SignInPage
      data-testid="SignIn"
      version={import.meta.env.VITE_VERSION}
      onSubmit={async credentials => {
        await signIn(credentials);
        // @ts-expect-error - Navigate to the redirect URL using router navigation
        await navigate({ to: redirectTo });
      }}
    >
      <Link
        className="mx-auto block max-w-full text-center text-base text-balance whitespace-normal text-primary-dark-gray"
        to="/recover-account"
      >
        {m.recover_account_password_forgotten()}
      </Link>
    </SignInPage>
  );
}
